import { Tag } from 'antd'
import CantileverButton from 'components/CantileverButton'
import CantileverRow from 'components/CantileverRow'
import { CDSTag, InspectionHeatmap, TextSm } from 'features/assetDatabase'
import { ArrowRight } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'
import { useGeckoTheme } from 'styles/GeckoTheme'
import {
  GeckoAssetModel,
  GeckoComponent,
  GeckoComponentDataFrame,
  GeckoInspection,
  GeckoUnit,
} from 'types'

const StyledRightArrow = styled(ArrowRight)`
  width: 16px;
  height: 16px;
  margin-left: 4px;
`

const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
`

export interface NiiInspectionRowProps {
  inspection: GeckoInspection
  unit: GeckoUnit
  component: GeckoComponent
  assetModel?: GeckoAssetModel
  componentDataFrame?: GeckoComponentDataFrame
  onNavigate: (
    inspection: GeckoInspection,
    event: React.MouseEvent,
    options?: { cdf?: string }
  ) => void
}

export const NiiInspectionRow: React.FC<NiiInspectionRowProps> = ({
  inspection,
  unit,
  component,
  assetModel,
  componentDataFrame,
}) => {
  const { theme } = useGeckoTheme()
  return (
    <CantileverRow
      key={inspection.id}
      vPadding='0.5rem'
      hPadding='0.5rem'
      leadingContent={
        <>
          <InspectionHeatmap
            unit={unit}
            inspection={inspection}
            component={component}
            assetModel={assetModel}
            componentDataFrame={componentDataFrame}
          />
          <TextSm>{component.data.name}</TextSm>
          <CDSTag inspection={inspection} />
          <Tag style={{ backgroundColor: theme.common.badge.background.blue }}>
            Coverage Area: 50.5%
          </Tag>
          <Tag style={{ backgroundColor: theme.common.badge.background.green }}>
            Eligible
          </Tag>
        </>
      }
      trailingContent={
        <ButtonGroup>
          <CantileverButton primary onClick={() => {}}>
            Open in Viewer
            <StyledRightArrow />
          </CantileverButton>
        </ButtonGroup>
      }
      onClick={() => {}}
    />
  )
}
